import applescript from "refractor/applescript";
export default applescript;